import { prefixObjectValues } from '../../utils';
const form = {
  startDate: 'start-date',
  laborReqType: 'laborReqType',
  endDate: 'end-date',
  numOfShifts: 'fte-shifts-per-year',
  hoursPerShift: 'hours-per-shift',
  totalShifts: 'total-shifts',
  totalHours: 'total-hours',
  numRvusReq: 'numRvusReq',
  minRvusPerShift: 'minRvusPerShift',
};
export default prefixObjectValues(form, 'labor-metrics-form');
